import { render, staticRenderFns } from "./GoLiveVersions.vue?vue&type=template&id=ff142eea&"
import script from "./GoLiveVersions.vue?vue&type=script&lang=js&"
export * from "./GoLiveVersions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports